import { createSelector } from '@reduxjs/toolkit';

import { clanItemSelector, currentAccountClanIdSelector, getCurrentClan } from './currentAccountSelector';

import type { RootState } from '~/store';

export const getClanBaseByClanId = (state: RootState, clanId: number) => state.supply[clanId]?.base || null;

export const supplyHasBuildPermissionSelector = (state: RootState) => state.ReducerSupply.hasBuildPermission;
export const supplyBuildingInProgressSelector = (state: RootState) => state.ReducerSupply.buildingInProgress;

export const supplyAccumulativeResSelector = createSelector(getCurrentClan, (currentLadderInfo) => {
  return currentLadderInfo?.accumulativeResource || 0;
});
export const supplyPersonalResSelector = createSelector(getCurrentClan, (currentLadderInfo) => {
  return currentLadderInfo?.personalResource || 0;
});

export const supplyViewSelector = (clanId: number) =>
  createSelector(
    clanItemSelector(clanId),
    currentAccountClanIdSelector,
    (state: RootState) => state.ReducerSupply,
    (activeClanLadderInfo, currentAccountClanId, supply) => {
      return {
        battlesStats: activeClanLadderInfo?.stats || {},
        buildings: supply.buildings,
        confirmBuildingId: supply.confirmBuildingId,
        isOwnBase: clanId === currentAccountClanId,
        isSidebarOpened: supply.isSidebarOpened,
        mapHost: supply.mapHost,
        prevSelectedBuildingId: supply.prevSelectedBuildingId,
        selectedBuildingId: supply.selectedBuildingId,
        tempHoverBuildingId: supply.tempHoverBuildingId,
        tempHoverBuildingLevel: supply.tempHoverBuildingLevel,
      };
    },
  );

export const supplyMapSelector = (clanId: number) =>
  createSelector(
    clanItemSelector(clanId),
    (state: RootState) => state.ReducerSupply,
    (activeClanLadderInfo, supply) => {
      return {
        battlesStats: activeClanLadderInfo ? activeClanLadderInfo.stats : {},
        // Supply data
        backgroundUrl: supply.backgroundUrl,
        buildings: supply.buildings,
        confirmBuildingId: supply.confirmBuildingId,
        edgesVisible: supply.edgesVisible,
        highlightDelay: supply.highlightDelay,
        highlightedBuildingId: supply.highlightedBuildingId,
        initialZoom: supply.initialZoom,
        isMapBlured: supply.isMapBlured,
        isSidebarOpened: supply.isSidebarOpened,
        prevPosition: supply.prevPosition,
        maxZoom: supply.maxZoom,
        minZoom: supply.minZoom,
        position: supply.position,
        selectedBuildingId: supply.selectedBuildingId,
        tempHoverBuildingId: supply.tempHoverBuildingId,
        tempHoverBuildingLevel: supply.tempHoverBuildingLevel,
        zoom: supply.zoom,
      };
    },
  );
